export default {

  UNKNOWN: {
    code: 1100,
    message: 'Unknown Error Occurred.'
  },

  INVALID_TOKENS: {
    code: 1200,
    message: `
      There was an error processing your request.
      To see the status of this order, please log into Grubhub for Restaurants at
    `,
    link: 'https://restaurant.grubhub.com',
    linkText: 'https://restaurant.grubhub.com'
  },

  TOKENS_EXPIRED: {
    code: 1300,
    message: `
      There was an error processing your request.
      To see the status of this order, please log into Grubhub for Restaurants at
    `,
    link: 'https://restaurant.grubhub.com',
    linkText: 'https://restaurant.grubhub.com'
  },

  CONFIRMATION_FAILURE: {
    code: 1400,
    message: 'There was an error confirming your order. Try again',
    link: function(data) {
      return `${data.custId ? `/${data.custId}` : ''}/${data.authToken}/${data.supervisorToken}`;
    },
    linkText: 'here'
  }

};



// WEBPACK FOOTER //
// ./client/app/config/errors.js